import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getApi } from './api-client';

export interface ApiRequestConfig extends AxiosRequestConfig {
  urlParams?: Record<string, string>;
}

function replaceUrlParams(url: string, params?: Record<string, string>): string {
  if (!params) return url;
  let result = url;
  for (const [key, value] of Object.entries(params)) {
    result = result.replace(new RegExp(`:${key}`, 'g'), value);
  }
  return result;
}

export function httpRequest<Request = unknown, Response = unknown>(
  method: 'post' | 'put' | 'patch',
  url: string,
): (data: Request, options?: ApiRequestConfig) => Promise<AxiosResponse<Response>>;
export function httpRequest<_Request = unknown, Response = unknown>(
  method: 'get' | 'delete',
  url: string,
): (options?: ApiRequestConfig) => Promise<AxiosResponse<Response>>;
export function httpRequest<Request = unknown, Response = unknown>(
  method: 'get' | 'post' | 'put' | 'delete' | 'patch',
  url: string,
) {
  if (method === 'post' || method === 'put' || method === 'patch') {
    return (data: Request, options?: ApiRequestConfig) =>
      getApi()[method]<Response>(replaceUrlParams(url, options?.urlParams), data, options);
  }
  return (options?: ApiRequestConfig) => getApi()[method]<Response>(replaceUrlParams(url, options?.urlParams), options);
}
